import React from 'react'
import './Spinner.css'
const Spinner = (props) => {
    return (
        <div className="backdrop">
            <div className="spinner"></div>
            <div className="message">{props.message}</div>
        </div>
    )
}

export default Spinner
